/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { useLocalizedFromContext } from 'data/Localization';

export const GradientCrop48 = ({ title, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" {...props}>
    <title>{useLocalizedFromContext(title)}</title>
    <defs>
      <clipPath id="b">
        <rect width="50" height="50" />
      </clipPath>
    </defs>
    <g id="a" clipPath="url(#b)">
      <rect width="50" height="50" fill="#fff" />
      <g transform="translate(-113.433 -10.293)">
        <path
          d="M135.493,49.656a1.41,1.41,0,0,0-.263.888,1.69,1.69,0,0,0,.067.471,1.153,1.153,0,0,0,.2.418,1.218,1.218,0,0,0,.221-.516,1.734,1.734,0,0,0,.042-.373A1.419,1.419,0,0,0,135.493,49.656Z"
          fill="none"
        />
        <path
          d="M154.545,36.349c-.016-.262-.019-.525-.052-.783a9.407,9.407,0,0,0-3.819-6.686A16.63,16.63,0,0,0,148.56,27.6a20.72,20.72,0,0,0-9.81-2.111c-.031,0-.059-.011-.09-.011s-.059.013-.09.011a20.142,20.142,0,0,0-11.924,3.389,9.056,9.056,0,0,0-3.37,4.654,10.992,10.992,0,0,0-.45,2.033,14.128,14.128,0,0,0,1.45,7.883,16.046,16.046,0,0,0,2.1,3.271c1.814,2.165,3.373,3.886,4.726,5.277,4.469,4.594,6.606,5.429,7.554,5.429,1.2,0,4.3-1.333,11.614-9.925.223-.261.436-.507.666-.781A15.067,15.067,0,0,0,154.545,36.349Zm-1.882.18c0,.092-.014.176-.019.266-.094,1.7-1.062,2.963-2.338,2.963a2.393,2.393,0,0,1-2.161-1.908,4.426,4.426,0,0,1-.2-1.321c0-1.841,1.014-3.229,2.356-3.229S152.663,34.688,152.663,36.529ZM144.388,42.2c0,1.811-1.126,3.229-2.563,3.229s-2.564-1.418-2.564-3.229a3.57,3.57,0,0,1,.923-2.479,2.262,2.262,0,0,1,1.641-.749,2.13,2.13,0,0,1,.809.174A3.192,3.192,0,0,1,144.388,42.2Zm-10.23-10.254c1.437,0,2.563,1.419,2.563,3.229S135.6,38.4,134.158,38.4s-2.564-1.418-2.564-3.229S132.72,31.943,134.158,31.943ZM133.1,41.38a2.71,2.71,0,0,1,2.474-2.411,2.428,2.428,0,0,1,2.086,1.342,3.823,3.823,0,0,1,.477,1.886c0,1.811-1.126,3.229-2.563,3.229s-2.563-1.418-2.563-3.229A4.09,4.09,0,0,1,133.1,41.38Zm10.141-9.437c1.437,0,2.563,1.419,2.563,3.229s-1.126,3.229-2.563,3.229-2.563-1.418-2.563-3.229S141.8,31.943,143.238,31.943Zm.854-4.753a2.054,2.054,0,0,1,2.149-.3,4.237,4.237,0,0,1,1.427.923c.087.084.176.165.258.255,1.259,1.383,1.476,3.022.515,3.9a1.83,1.83,0,0,1-1.259.468,2.629,2.629,0,0,1-.889-.165,4.39,4.39,0,0,1-1.686-1.179,3.926,3.926,0,0,1-1.1-2.3A1.909,1.909,0,0,1,144.092,27.19Zm-5.337-.682a2.811,2.811,0,0,1,2.53,2.8,4.264,4.264,0,0,1,.033.428c0,1.811-1.126,3.229-2.563,3.229a2.731,2.731,0,0,1-2.491-2.48,4.135,4.135,0,0,1-.073-.749C136.191,27.927,137.317,26.508,138.755,26.508Zm-9.8,5.456a2.055,2.055,0,0,1-.5-2.11,4.389,4.389,0,0,1,1.014-1.788c1.262-1.383,2.872-1.752,3.834-.876a2.054,2.054,0,0,1,.5,2.11,4.379,4.379,0,0,1-1.015,1.788c-.1.106-.2.191-.3.285a3.618,3.618,0,0,1-2.165,1.057c-.034,0-.067,0-.1,0a1.905,1.905,0,0,1-1.021-.287A1.714,1.714,0,0,1,128.955,31.964Zm.492,4.565c0,1.841-1.014,3.229-2.357,3.229s-2.357-1.388-2.357-3.229,1.014-3.229,2.357-3.229S129.447,34.688,129.447,36.529Zm-.268,10.624a4.382,4.382,0,0,1-1.516-1.392,3.536,3.536,0,0,1-.684-2.945,1.8,1.8,0,0,1,.7-.99,2.059,2.059,0,0,1,2.17-.016,3.446,3.446,0,0,1,.392.241,4.639,4.639,0,0,1,1.125,1.151,4.374,4.374,0,0,1,.768,1.91,2.06,2.06,0,0,1-.781,2.025,1.792,1.792,0,0,1-1.032.316A2.479,2.479,0,0,1,129.179,47.153Zm6.314,6.62a2.663,2.663,0,0,1-2.431-2.233,4.066,4.066,0,0,1-.133-1c0-1.811,1.126-3.229,2.564-3.229,1.39,0,2.479,1.331,2.55,3.056,0,.059.013.114.013.173C138.056,52.354,136.93,53.773,135.493,53.773Zm8.974-3.229c0,1.81-1.126,3.229-2.563,3.229s-2.563-1.419-2.563-3.229a4.269,4.269,0,0,1,.037-.486,2.8,2.8,0,0,1,2.526-2.743,2.5,2.5,0,0,1,2.224,1.629A3.91,3.91,0,0,1,144.467,50.544Zm6.035-6.692a4.66,4.66,0,0,1-2.286,3.3,2.469,2.469,0,0,1-1.136.3,1.791,1.791,0,0,1-1.034-.317,2.061,2.061,0,0,1-.78-2.025,4.377,4.377,0,0,1,.769-1.909c1.063-1.538,2.612-2.118,3.686-1.376A2.061,2.061,0,0,1,150.5,43.852Z"
          fill="none"
        />
        <ellipse
          cx="0.263"
          cy="0.888"
          rx="0.263"
          ry="0.888"
          transform="translate(142.975 34.284)"
          fill="none"
        />
        <ellipse
          cx="0.263"
          cy="0.888"
          rx="0.263"
          ry="0.888"
          transform="translate(141.641 49.656)"
          fill="none"
        />
        <ellipse
          cx="0.263"
          cy="0.888"
          rx="0.263"
          ry="0.888"
          transform="translate(133.895 34.284)"
          fill="none"
        />
        <path
          d="M127.034,36.529a2.206,2.206,0,0,0,.056.512,2.368,2.368,0,0,0,0-1.024A2.212,2.212,0,0,0,127.034,36.529Z"
          fill="none"
        />
        <path
          d="M139.009,29.843c0-.036.008-.068.008-.106a1.423,1.423,0,0,0-.262-.888,1.415,1.415,0,0,0-.263.888,1.919,1.919,0,0,0,.018.223,1.3,1.3,0,0,0,.245.665A1.387,1.387,0,0,0,139.009,29.843Z"
          fill="none"
        />
        <ellipse
          cx="0.263"
          cy="0.888"
          rx="0.263"
          ry="0.888"
          transform="translate(135.308 41.309)"
          fill="none"
        />
        <ellipse
          cx="0.263"
          cy="0.888"
          rx="0.263"
          ry="0.888"
          transform="translate(141.562 41.309)"
          fill="none"
        />
        <path
          d="M147.36,20.747a7.654,7.654,0,0,0,.143-2.375,7.511,7.511,0,0,1-4.029,2.59,2.815,2.815,0,0,0-2.15,2.078C144.226,22.672,147.126,21.754,147.36,20.747Z"
          fill="none"
        />
        <path
          d="M138.66,12.954c-.965.95-2.224,2.6-1.985,4.2a18.184,18.184,0,0,0,.768,2.9c.416,1.238.891,2.425,1.187,3.13l.029,0,.031,0c.345-.823.935-2.3,1.388-3.748a15.74,15.74,0,0,0,.566-2.286C140.882,15.552,139.624,13.9,138.66,12.954Z"
          fill="none"
        />
        <ellipse
          cx="0.056"
          cy="0.51"
          rx="0.056"
          ry="0.51"
          transform="translate(150.251 36.019)"
          fill="none"
        />
        <path
          d="M129.816,18.371a7.628,7.628,0,0,0,.143,2.376c.07.3.382.594.858.867a15.642,15.642,0,0,0,5.178,1.426,2.816,2.816,0,0,0-2.15-2.078c-.039-.009-.074-.022-.113-.032A7.549,7.549,0,0,1,129.816,18.371Z"
          fill="none"
        />
        <path
          d="M135.714,50.917a1.218,1.218,0,0,1-.221.516,1.153,1.153,0,0,1-.2-.418l-2.235.525a2.663,2.663,0,0,0,2.431,2.233c1.437,0,2.563-1.419,2.563-3.229,0-.059-.011-.114-.013-.173Z"
          fill="#b95700"
        />
        <path
          d="M138.66,59.727c2.987,0,7.449-3.664,14.043-11.529a18.1,18.1,0,0,0,1.149-1.536l-3.578.84c-7.318,8.592-10.416,9.925-11.614,9.925-.948,0-3.085-.835-7.554-5.429l-2.6.609C134.384,58.875,137.091,59.727,138.66,59.727Z"
          fill="#b95700"
        />
        <path
          d="M139.341,50.544c0,1.81,1.125,3.229,2.563,3.229s2.563-1.419,2.563-3.229a3.91,3.91,0,0,0-.339-1.6l-4.75,1.114A4.269,4.269,0,0,0,139.341,50.544Zm2.563-.888a1.631,1.631,0,0,1,0,1.776,1.631,1.631,0,0,1,0-1.776Z"
          fill="#b95700"
        />
        <path
          d="M150.306,39.758c1.276,0,2.244-1.259,2.338-2.963l-4.5,1.055A2.393,2.393,0,0,0,150.306,39.758Z"
          fill="#eb6909"
        />
        <path
          d="M139.261,42.2c0,1.811,1.126,3.229,2.564,3.229s2.563-1.418,2.563-3.229a3.192,3.192,0,0,0-1.754-3.054l-2.45.575A3.57,3.57,0,0,0,139.261,42.2Zm2.564-.888a1.631,1.631,0,0,1,0,1.776,1.631,1.631,0,0,1,0-1.776Z"
          fill="#eb6909"
        />
        <path
          d="M126.38,46.721a16.046,16.046,0,0,1-2.1-3.271l-2.29.537a18.275,18.275,0,0,0,2.631,4.211c1.439,1.717,2.723,3.161,3.893,4.409l2.6-.609C129.753,50.607,128.194,48.886,126.38,46.721Z"
          fill="#eb6909"
        />
        <path
          d="M149.721,41.826c-1.074-.742-2.623-.162-3.686,1.376a4.377,4.377,0,0,0-.769,1.909,2.061,2.061,0,0,0,.78,2.025,1.791,1.791,0,0,0,1.034.317,2.469,2.469,0,0,0,1.136-.3,4.66,4.66,0,0,0,2.286-3.3A2.061,2.061,0,0,0,149.721,41.826Z"
          fill="#eb6909"
        />
        <path
          d="M132.13,45.112a4.374,4.374,0,0,0-.768-1.91,4.639,4.639,0,0,0-1.125-1.151l-3.258.765a3.536,3.536,0,0,0,.684,2.945,4.382,4.382,0,0,0,1.516,1.392,2.479,2.479,0,0,0,1.138.3,1.792,1.792,0,0,0,1.032-.316A2.06,2.06,0,0,0,132.13,45.112Z"
          fill="#eb6909"
        />
        <path
          d="M150.94,46.721c-.23.274-.443.52-.666.781l3.578-.84a17.056,17.056,0,0,0,2.96-10.845l-2.267.532A15.067,15.067,0,0,1,150.94,46.721Z"
          fill="#eb6909"
        />
        <path
          d="M141.9,47.315a2.8,2.8,0,0,0-2.526,2.743l4.75-1.114A2.5,2.5,0,0,0,141.9,47.315Z"
          fill="#eb6909"
        />
        <path
          d="M135.571,45.426c1.437,0,2.563-1.418,2.563-3.229a3.823,3.823,0,0,0-.477-1.886L133.1,41.38a4.09,4.09,0,0,0-.089.817C133.008,44.008,134.133,45.426,135.571,45.426Zm0-4.117a1.631,1.631,0,0,1,0,1.776,1.631,1.631,0,0,1,0-1.776Z"
          fill="#eb6909"
        />
        <path
          d="M135.23,50.544a1.41,1.41,0,0,1,.263-.888,1.419,1.419,0,0,1,.263.888,1.734,1.734,0,0,1-.042.373l2.329-.546c-.071-1.725-1.16-3.056-2.55-3.056-1.438,0-2.564,1.418-2.564,3.229a4.066,4.066,0,0,0,.133,1l2.235-.525A1.69,1.69,0,0,1,135.23,50.544Z"
          fill="#eb6909"
        />
        <path
          d="M140.184,39.718l2.45-.575a2.13,2.13,0,0,0-.809-.174A2.262,2.262,0,0,0,140.184,39.718Z"
          fill="#5f9501"
        />
        <path
          d="M135.571,38.969A2.71,2.71,0,0,0,133.1,41.38l4.56-1.069A2.428,2.428,0,0,0,135.571,38.969Z"
          fill="#5f9501"
        />
        <path
          d="M147.95,36.529a4.426,4.426,0,0,0,.2,1.321l4.5-1.055c.005-.09.019-.174.019-.266,0-1.841-1.014-3.229-2.357-3.229S147.95,34.688,147.95,36.529Zm2.356-.51a2.355,2.355,0,0,1,0,1.021,2.4,2.4,0,0,1,0-1.021Z"
          fill="#5f9501"
        />
        <path
          d="M134.158,38.4c1.437,0,2.563-1.418,2.563-3.229s-1.126-3.229-2.563-3.229-2.564,1.419-2.564,3.229S132.72,38.4,134.158,38.4Zm0-4.117a1.632,1.632,0,0,1,0,1.777,1.632,1.632,0,0,1,0-1.777Z"
          fill="#5f9501"
        />
        <path
          d="M138.755,30.625a1.3,1.3,0,0,1-.245-.665l-2.246.526a2.731,2.731,0,0,0,2.491,2.48c1.437,0,2.563-1.418,2.563-3.229a4.264,4.264,0,0,0-.033-.428l-2.276.534A1.387,1.387,0,0,1,138.755,30.625Z"
          fill="#5f9501"
        />
        <path
          d="M130.32,32.43a3.618,3.618,0,0,0,2.165-1.057l-3.288.772a1.905,1.905,0,0,0,1.021.287C130.253,32.432,130.286,32.432,130.32,32.43Z"
          fill="#5f9501"
        />
        <path
          d="M129.845,41.81a2.059,2.059,0,0,0-2.17.016,1.8,1.8,0,0,0-.7.99l3.258-.765A3.446,3.446,0,0,0,129.845,41.81Z"
          fill="#5f9501"
        />
        <path
          d="M124.733,36.529c0,1.841,1.014,3.229,2.357,3.229s2.357-1.388,2.357-3.229S128.433,33.3,127.09,33.3,124.733,34.688,124.733,36.529Zm2.357.512a2.369,2.369,0,0,1,0-1.024,2.368,2.368,0,0,1,0,1.024Z"
          fill="#5f9501"
        />
        <path
          d="M143.238,38.4c1.437,0,2.563-1.418,2.563-3.229s-1.126-3.229-2.563-3.229-2.563,1.419-2.563,3.229S141.8,38.4,143.238,38.4Zm0-4.117a1.632,1.632,0,0,1,0,1.777,1.632,1.632,0,0,1,0-1.777Z"
          fill="#5f9501"
        />
        <path
          d="M150.674,28.88a9.407,9.407,0,0,1,3.819,6.686c.033.258.036.521.052.783l2.267-.532c-.016-.18-.014-.362-.037-.541a11.8,11.8,0,0,0-4.764-8.267c-.081-.058-.164-.1-.245-.159l-3.206.752A16.63,16.63,0,0,1,150.674,28.88Z"
          fill="#5f9501"
        />
        <path
          d="M122.826,35.567a10.992,10.992,0,0,1,.45-2.033l-2.53.593c-.081.377-.152.76-.2,1.151a16.33,16.33,0,0,0,1.441,8.709l2.29-.537A14.128,14.128,0,0,1,122.826,35.567Z"
          fill="#5f9501"
        />
        <path
          d="M144.607,31.088a4.39,4.39,0,0,0,1.686,1.179,2.629,2.629,0,0,0,.889.165,1.83,1.83,0,0,0,1.259-.468c.961-.876.744-2.515-.515-3.9-.082-.09-.171-.171-.258-.255l-4.156.975A3.926,3.926,0,0,0,144.607,31.088Z"
          fill="#5f9501"
        />
        <path
          d="M126.646,28.88a20.142,20.142,0,0,1,11.924-3.389c.031,0,.059-.011.09-.011s.059.014.09.011a20.72,20.72,0,0,1,9.81,2.111l3.206-.752a20.066,20.066,0,0,0-5.444-2.635c1.6-.628,2.954-1.557,3.278-2.946a10.533,10.533,0,0,0,.068-4.078l-9.59,2.25c-.453,1.45-1.043,2.925-1.388,3.748l-.031,0-.029,0c-.3-.7-.771-1.892-1.187-3.13l-3.711.871c.039.01.074.023.113.032a2.816,2.816,0,0,1,2.15,2.078,15.642,15.642,0,0,1-5.178-1.426l-2.665.625A6.064,6.064,0,0,0,131,24.215a19.974,19.974,0,0,0-5.69,2.794,11.637,11.637,0,0,0-4.562,7.118l2.53-.593A9.056,9.056,0,0,1,126.646,28.88Zm16.828-7.918a7.511,7.511,0,0,0,4.029-2.59,7.654,7.654,0,0,1-.143,2.375c-.234,1.007-3.134,1.925-6.036,2.293A2.815,2.815,0,0,1,143.474,20.962Z"
          fill="#79b61d"
        />
        <path
          d="M132.789,31.088A4.379,4.379,0,0,0,133.8,29.3a2.054,2.054,0,0,0-.5-2.11c-.962-.876-2.572-.507-3.834.876a4.389,4.389,0,0,0-1.014,1.788,2.055,2.055,0,0,0,.5,2.11,1.714,1.714,0,0,0,.242.181l3.288-.772C132.587,31.279,132.693,31.194,132.789,31.088Z"
          fill="#79b61d"
        />
        <path
          d="M147.668,27.811a4.237,4.237,0,0,0-1.427-.923,2.054,2.054,0,0,0-2.149.3,1.909,1.909,0,0,0-.58,1.6Z"
          fill="#79b61d"
        />
        <path
          d="M138.51,29.96a1.919,1.919,0,0,1-.018-.223,1.415,1.415,0,0,1,.263-.888,1.423,1.423,0,0,1,.262.888c0,.038-.006.07-.008.106l2.276-.534a2.811,2.811,0,0,0-2.53-2.8c-1.438,0-2.564,1.419-2.564,3.229a4.135,4.135,0,0,0,.073.749Z"
          fill="#79b61d"
        />
        <path
          d="M129.959,20.747a7.628,7.628,0,0,1-.143-2.376,7.549,7.549,0,0,0,3.916,2.559l3.711-.871a18.184,18.184,0,0,1-.768-2.9c-.239-1.6,1.02-3.251,1.985-4.2.964.95,2.222,2.6,1.984,4.2a15.74,15.74,0,0,1-.566,2.286l9.59-2.25a11.934,11.934,0,0,0-.59-2.254,1.148,1.148,0,0,0-1.069-.721h0a1.152,1.152,0,0,0-1.068.734c-.013.031-1.253,3.135-3.985,3.772-.108.025-.205.059-.307.089.116-.46.212-.907.274-1.318.567-3.819-3.4-6.86-3.568-6.988-.019-.014-.042-.016-.062-.029a1.047,1.047,0,0,0-.216-.1,1.07,1.07,0,0,0-.2-.067,1.1,1.1,0,0,0-.223-.012,1.059,1.059,0,0,0-.211.011,1.142,1.142,0,0,0-.206.071,1.071,1.071,0,0,0-.205.1c-.021.014-.046.017-.067.032-.168.128-4.135,3.169-3.568,6.988.061.411.158.858.274,1.318-.1-.03-.2-.064-.306-.089-2.733-.637-3.973-3.741-3.984-3.768a1.148,1.148,0,0,0-1.065-.74,1.108,1.108,0,0,0-1.076.723,11.758,11.758,0,0,0-.524,6.332,2.887,2.887,0,0,0,.434.97l2.665-.625C130.341,21.341,130.029,21.048,129.959,20.747Z"
          fill="#c8d200"
        />
      </g>
    </g>
  </svg>
);

GradientCrop48.defaultProps = {
  title: 'strawberry',
};

GradientCrop48.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
